export const nomineeType = {
    parents: 1,
    travelbuddy: 2,
    spouse: 3,
    childOfEmployee: 4,
    friends: 5
}
export const nomineeTypeMap = {
    [nomineeType.parents]: "Parents",
    [nomineeType.travelbuddy]: "Travelbuddy",
    [nomineeType.spouse]: "Spouse",
    [nomineeType.childOfEmployee]: "Child of Employee",
    [nomineeType.friends]: "Friends"
}
export const nomineeStatus = {
    draft: 1,
    send: 2,
    approved: 3,
    declined: 4
}
export const nomineeStatusMap = {
    1: "Draft",
    2: "Pending",
    3: "Approved",
    4: "Declined"
}
export const employeementType = {
    fulltime: 1,
    partime: 2
}
export const employeementMap = {
    1: 'FullTime',
    2: 'PartTime'
}
export const tripType = {
    roundTrip: 1,
    oneWay: 2,
    multiCity: 3
}
export const tripTypeMap = {
    [tripType.oneWay]: 'single',
    [tripType.roundTrip]: 'roundTrip',
    [tripType.multiCity]: 'multiCity'
}
export const standbyBookingType = {
    staffAndFamily: 1,
    friends: 2
}
export const entitlementTypes = {
    standby: 1,
    confirmed: 2
}
export const entitlementTypeMap = {
    [entitlementTypes.standby]: 'standby',
    [entitlementTypes.confirmed]: 'confirmed'
}

export const segmentStatus = entitlementTypes;
export const segmentStatusMap = entitlementTypeMap;

export const flightStatus = {
    all: 0,
    upcoming: 1,
    cancelled: 2,
    flown: 3
}
export const flightStatusMap = {
    0: 'All',
    1: 'Upcoming',
    2: 'Cancelled',
    3: 'Flown'
}
export const gender = {
    male: 1,
    female: 2
}
export const genderMap = {
    [gender.male]: 'Male',
    [gender.female]: 'Female'
}
export const title = {
    mr: 'MR',
    ms: 'MS',
    miss: 'MISS',
    mstr: 'MSTR'
}
export const titleMap = {
    [title.mr]: 'Mr.',
    [title.ms]: 'Ms.',
    [title.miss]: 'Miss',
    [title.mstr]: 'MSTR'
}
export const marialStatus = {
    married: 2,
    unmarried: 1
}
export const marialStatusMap = {
    [marialStatus.married]: 'Married',
    [marialStatus.unmarried]: 'Unmarried'
}